import { render, staticRenderFns } from "./NuevoRegistroOdontograma.vue?vue&type=template&id=00438e20&scoped=true"
import script from "./NuevoRegistroOdontograma.vue?vue&type=script&lang=js"
export * from "./NuevoRegistroOdontograma.vue?vue&type=script&lang=js"
import style0 from "./NuevoRegistroOdontograma.vue?vue&type=style&index=0&id=00438e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00438e20",
  null
  
)

export default component.exports